import { propagationAxios } from 'trace-propagation';

import {
    ContentApi as ContentServiceApi,
    Configuration,
    V2Api as CollectionApi,
    GroupApi as ContentServiceGroupApi,
} from '@videoblocks/content-service-client';

import ContentServiceClient from './src/ContentServiceClient';
import { ContentClassEnum, ContentHistory } from './src/types';

const { CONTENT_HOST = 'http://localhost:9500' } = process.env;

const configuration = new Configuration({
    basePath: CONTENT_HOST,
});

// `propagationAxios` forwards incoming propagation headers to content-service
// for Signadot sandbox routing.
const contentApi = new ContentServiceApi(configuration, undefined, propagationAxios);
const collectionApi = new CollectionApi(configuration, undefined, propagationAxios);
const groupApi = new ContentServiceGroupApi(configuration, undefined, propagationAxios);

export { ContentClassEnum, type ContentHistory };

const contentServiceClient = new ContentServiceClient(collectionApi, contentApi, groupApi);
export default contentServiceClient;

export * from './src/serverActions';
